import { z } from "zod";

export enum EMyVPlanningMode {
  NORMAL = "normal",
  ECO = "eco",
  TEMPERATURE = "temperature",
  COMFORT_ON = "comfort/on",
  COMFORT_1 = "comfort-1",
  COMFORT_2 = "comfort-2",
  NO_FROST = "no-frost",
  STOP = "stop",
  ECO_V = "eco-v",
  UNKNOWN = "unknown",
}

export const myvPlanningModeDtoSchema = z.nativeEnum(EMyVPlanningMode);
export type TMyvPlanningModeDto = z.infer<typeof myvPlanningModeDtoSchema>;
